function toggleZigexnFooter() {
  const content = document.getElementById('js--zigexn-accordion-content');
  const icon = document.querySelector('#zigexn-footer .js--accordion-icons');
  
  if(content.classList.contains('open')) {
    content.classList.remove('open');
    content.classList.add('d-none');
    icon.textContent = '+';
  } else {
    content.classList.add('open');
    content.classList.remove('d-none');
    icon.textContent = '−';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const accordionHeader = document.querySelector('#zigexn-footer .js--accordion-header');
  if (accordionHeader) {
    accordionHeader.addEventListener('click', toggleZigexnFooter);
  }
});
